import React from "react";
import styled from "styled-components";
import { FaMoon, FaSun } from "react-icons/fa";

const Container = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
`;

const Title = styled.h1``;

const Mode = styled.span`
  font-weight: bold;
  letter-spacing: 2.5px;
  margin-right: 10px;
`;

const ThemeToggler = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Header = ({ isThemeDark, setIsThemeDark }) => {
  return (
    <Container>
      <Title>devfinder</Title>
      <ThemeToggler onClick={() => setIsThemeDark(!isThemeDark)}>
        <Mode>{isThemeDark ? "LIGHT" : "DARK"}</Mode>
        {isThemeDark ? <FaSun /> : <FaMoon />}
      </ThemeToggler>
    </Container>
  );
};

export default Header;
